import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { ReactComponent as DownArrowSvg } from '../../../image/DownArrow2.svg';
import { ReactComponent as CheckSvg } from '../../../image/Check4.svg';
import { useLanguage } from '../../../Context/LanguageContext';
import CustomScrollbar from '../../../Model/Share/Normal/CustomScrollbar';

export default function SelectMembershipBox(props) {
  const {
    value,
    setValue,
    memberships,
    pointColor
  } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const pc = pointColor || theme.primary;

  const [isClicked, setIsClicked] = useState(false);

  const ButtonRef = useRef(null);
  const SelectBoxRef = useRef(null);
  const ScrollAreaRef = useRef(null);

  // 컴포넌트 외부 클릭시 이벤트를 받기위한 리스너 연결
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 컴포넌트 외부 클릭시 실행
  function onClickOutSide(e) {
    if (SelectBoxRef.current !== e.target
      && !SelectBoxRef.current.contains(e.target)
      && ButtonRef.current !== e.target
      && !ButtonRef.current.contains(e.target)) {
      SelectBoxRef.current.style.height = `0px`;
      setIsClicked(false);
    }
  }

  // 더보기 클릭시 //
  function onClickMemberships() {
    if (isClicked) {
      SelectBoxRef.current.style.height = `0px`;
      setIsClicked(false);
    }
    else {
      SelectBoxRef.current.style.height = (32 * (memberships.length + 1)) > 230 ? `230px` : ((32 * (memberships.length + 1)) + 'px');
      setIsClicked(true);
    }
  }

  // 수업 클릭시
  function optionalClick(index) {
    // 입력시 중복확인 => 존재하면 삭제, 존재하지 않으면 추가
    let newDefaultVal = value.slice();

    if (newDefaultVal.includes(memberships[index])) {
      let deletedIndex = 0;

      newDefaultVal.filter(function (item, idx) {
        // 두개가 같으면
        if (memberships[index] === item) {
          deletedIndex = idx;
          return;
        }
      })

      newDefaultVal.splice(deletedIndex, 1);
      setValue(newDefaultVal);
    }
    else {
      newDefaultVal.push(memberships[index]);
      setValue(newDefaultVal);
    }
  }

  // 확인 버튼 클릭시 //
  function onClickComplete() {
    SelectBoxRef.current.style.height = `0px`;
    setIsClicked(false);
  }

  // 초기화 버튼 클릭시 //
  function onClickReset() {
    SelectBoxRef.current.style.height = `0px`;
    setValue([]);
    setIsClicked(false);
  }

  return (
    <StatusBoxWrapper>
      <StatusBox ref={ButtonRef} isClicked={isClicked} $hasSelected={value.length > 0} $pointColor={pc} onClick={onClickMemberships}>
        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={isClicked ? pc : theme.text} hover='pointer'>{t('memberRegistration.membershipInfo')}</Text>
        {
          (value.length === 0) &&
          <ArrowWrapper isClicked={isClicked}>
            <StyledArrow $isClicked={isClicked} $pointColor={pc} />
          </ArrowWrapper>
        }
        {
          (value.length !== 0) &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? pc : theme.text} hover='pointer'>:</Text>
        }
        {
          (value.length > 0) &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? pc : theme.text} hover='pointer'>{value[0].membershipName}</Text>
        }
        {
          (value.length > 1) &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? pc : theme.text} hover='pointer'>, ...</Text>
        }
      </StatusBox>
      <SelectBox ref={SelectBoxRef} isClicked={isClicked} $isDark={isDark} $pointColor={pc}>
        <SelectBoxScroll ref={ScrollAreaRef}>
          {
            memberships.map((data, index) => (
              <OptionWrapper key={'Options-' + index} onClick={() => optionalClick(index)}>
                <TextWrapper>
                  <Option isClicked={value.includes(data)} $pointColor={pc}>{data.membershipName}</Option>
                </TextWrapper>
                {
                  value.includes(data) &&
                  <StyledCheck $pointColor={pc} />
                }
              </OptionWrapper>
            ))
          }

          <CompleteButtonWrapper>
            <TextButton onClick={onClickComplete} $pointColor={pc}>{t('memberDetail.extensionModal.btnConfirm')}</TextButton>
            <TextButton onClick={onClickReset} $pointColor={pc}>{t('memberDetail.extensionModal.filterReset')}</TextButton>
          </CompleteButtonWrapper>
        </SelectBoxScroll>
        {
          isClicked &&
          <ScrollbarOverlay>
            <CustomScrollbar
              direction='vertical'
              scrollRef={ScrollAreaRef}
              thumbSize='auto'
              thumbThickness={2}
              trackOffset={0}
              trackColor='transparent' />
          </ScrollbarOverlay>
        }
      </SelectBox>
    </StatusBoxWrapper>
  )
}

const StatusBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const StatusBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: ${props => props.$hasSelected ? 'flex-start' : 'space-between'};
  align-items: center;

  padding: 0px 10px;

  box-sizing: border-box;
  width: ${props => props.$hasSelected ? 'fit-content' : '130px'};
  height: 31px;

  gap: 4px;

  border: 1px solid ${props => props.isClicked ? props.$pointColor : props.theme.buttonStroke};
  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.subBackground : props.theme.buttonFill};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const ArrowWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 10px;
  height: 10px;

  transition: all 0.3s ease-in-out;

  transform: ${props => props.isClicked ? `rotateZ(180deg)` : `rotateZ(0deg)`};
`;

const StyledArrow = styled(DownArrowSvg)`
  width: 8px;
  height: auto;
  flex-shrink: 0;

  & path {
    fill: ${props => props.$isClicked ? props.$pointColor : props.theme.text};
  }

  transition: all 0.3s ease-in-out;
`;

const SelectBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 37px;

  width: 226.24px;
  height: ${props => props.isClicked ? `70px` : `0px`};

  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  border-radius: 5px;
  border: 1px solid ${props => props.isClicked ? props.$pointColor : 'transparent'};
  background-color: ${props => props.theme.subBackground};

  overflow: hidden;

  transition: all 0.3s ease-in-out;

	@media (hover: hover) and (pointer: fine) {
		&:hover {
			cursor: pointer;
		}
	}
`;

const SelectBoxScroll = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  overflow-x: hidden;
  overflow-y: auto;

  scrollbar-width: none;

  &::-webkit-scrollbar {
    width: 0;
  }
`;

const ScrollbarOverlay = styled.div`
  position: absolute;
  top: 5px;
  right: 4px;
  bottom: 34px;

  width: 2px;

  pointer-events: auto;
  z-index: 1;
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 5px 10px;

  box-sizing: border-box;
  width: 100%;
  height: 31px;

  gap: 5px;

  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Option = styled.div`
	font-family: NotoSansKR-Regular;
	font-size: 14px;

  color: ${props => props.isClicked ? props.$pointColor : props.theme.text};

  margin: 0 0 0 0;
  padding: 0 0 0 0;

  width: 100%;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledCheck = styled(CheckSvg)`
  width: 12px;
  height: 12px;
  flex-shrink: 0;

  & path {
    fill: ${props => props.$pointColor};
  }
`;

const CompleteButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  box-sizing: border-box;
  width: 100%;
  height: 31px;
`;

const TextButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 80px;
  height: 31px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
      color: ${props => props.$pointColor};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  // margin: 6px 0 6px 0;

  width: calc(100% - 16px);
  height: 19px;

  overflow: hidden;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }

  transition: all 0.3s ease-in-out;
`;
